var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 41,
    viewBox: "0 0 136 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_5677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.166 40.5H5.16981C2.41308 40.5 0.167969 38.2456 0.167969 35.5V5.5C0.167969 2.74439 2.41308 0.5 5.16981 0.5H130.166C132.92 0.5 135.168 2.74439 135.168 5.5V35.5C135.168 38.2456 132.92 40.5 130.166 40.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.166 1.3005C132.478 1.3005 134.371 3.18828 134.371 5.5V35.5C134.371 37.8117 132.491 39.6995 130.166 39.6995H5.16981C2.85764 39.6995 0.965183 37.8117 0.965183 35.5V5.5C0.965183 3.18828 2.84522 1.3005 5.16981 1.3005H130.166ZM130.166 0.5H5.16981C2.41308 0.5 0.167969 2.75436 0.167969 5.5V35.5C0.167969 38.2556 2.41308 40.5 5.16981 40.5H130.166C132.92 40.5 135.168 38.2556 135.168 35.5V5.5C135.168 2.75436 132.92 0.5 130.166 0.5Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2871 13.732C70.3856 13.732 69.6256 13.4153 69.0246 12.7918C68.4286 12.1858 68.0958 11.3504 68.1107 10.4975C68.1107 9.58732 68.4186 8.81675 69.0246 8.20577C69.6232 7.58233 70.3831 7.26562 71.2846 7.26562C72.1762 7.26562 72.9362 7.58233 73.5471 8.20577C74.1531 8.8367 74.461 9.60727 74.461 10.4975C74.4511 11.4103 74.1432 12.1808 73.5471 12.7893C72.9486 13.4177 72.1886 13.732 71.2871 13.732ZM44.4626 13.732C43.581 13.732 42.816 13.4202 42.1902 12.8043C41.5693 12.1908 41.2539 11.4153 41.2539 10.5C41.2539 9.58483 41.5693 8.80927 42.1902 8.1958C42.8036 7.57984 43.5685 7.26812 44.4626 7.26812C44.8997 7.26812 45.3244 7.3554 45.7317 7.53246C46.1315 7.70453 46.4569 7.93894 46.6978 8.22572L46.7574 8.29804L46.0844 8.96139L46.0148 8.87909C45.6348 8.42523 45.1257 8.20328 44.4527 8.20328C43.8517 8.20328 43.3276 8.41774 42.8955 8.84169C42.4609 9.26812 42.2399 9.82672 42.2399 10.5025C42.2399 11.1783 42.4609 11.7369 42.8955 12.1634C43.3276 12.5873 43.8517 12.8018 44.4527 12.8018C45.0934 12.8018 45.6324 12.5873 46.0521 12.1634C46.3004 11.914 46.4544 11.5649 46.509 11.1235H44.3509V10.1908H47.4354L47.4478 10.2756C47.4702 10.4327 47.4925 10.5948 47.4925 10.7444C47.4925 11.6048 47.2342 12.3005 46.7226 12.8143C46.1415 13.4227 45.3815 13.732 44.4626 13.732ZM80.1284 13.5998H79.1773L76.2641 8.91899L76.2889 9.76188V13.5973H75.3377V7.40029H76.423L76.4528 7.44767L79.1922 11.8566L79.1673 11.0162V7.40029H80.1284V13.5998ZM64.1395 13.5998H63.1759V8.33296H61.5045V7.40029H65.8085V8.33296H64.1371V13.5998H64.1395ZM60.7197 13.5998H59.7586V7.40029H60.7197V13.5998ZM55.3181 13.5998H54.357V8.33296H52.6855V7.40029H56.9895V8.33296H55.3181V13.5998ZM52.0771 13.5898H48.3915V7.40029H52.0771V8.33296H49.3551V10.0337H51.8113V10.9564H49.3551V12.6571H52.0771V13.5898ZM69.7299 12.1509C70.1596 12.5823 70.6811 12.7993 71.2871 12.7993C71.9105 12.7993 72.4196 12.5873 72.8443 12.1509C73.2665 11.727 73.4801 11.1709 73.4801 10.5C73.4801 9.82922 73.2665 9.27061 72.8468 8.84917C72.4171 8.41774 71.8931 8.20079 71.2896 8.20079C70.6662 8.20079 70.1571 8.41276 69.7349 8.84917C69.3127 9.27311 69.0991 9.82922 69.0991 10.5C69.0991 11.1709 69.3102 11.7295 69.7299 12.1509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0208 22.2557C65.6738 22.2557 63.7714 24.0437 63.7714 26.51C63.7714 28.9539 65.6863 30.7644 68.0208 30.7644C70.3677 30.7644 72.2701 28.9639 72.2701 26.51C72.2701 24.0437 70.3677 22.2557 68.0208 22.2557ZM68.0208 29.0786C66.7368 29.0786 65.6316 28.0113 65.6316 26.5001C65.6316 24.9664 66.7393 23.9215 68.0208 23.9215C69.3048 23.9215 70.4099 24.9664 70.4099 26.5001C70.4124 28.0212 69.3048 29.0786 68.0208 29.0786ZM58.7497 22.2557C56.4028 22.2557 54.5004 24.0437 54.5004 26.51C54.5004 28.9539 56.4152 30.7644 58.7497 30.7644C61.0967 30.7644 62.9991 28.9639 62.9991 26.51C62.9991 24.0437 61.0942 22.2557 58.7497 22.2557ZM58.7497 29.0786C57.4657 29.0786 56.3606 28.0113 56.3606 26.5001C56.3606 24.9664 57.4682 23.9215 58.7497 23.9215C60.0337 23.9215 61.1389 24.9664 61.1389 26.5001C61.1389 28.0212 60.0337 29.0786 58.7497 29.0786ZM47.7179 23.5549V25.3554H52.0218C51.8902 26.3654 51.5574 27.111 51.0483 27.6222C50.4175 28.2557 49.4439 28.9439 47.7278 28.9439C45.0828 28.9439 43.014 26.7993 43.014 24.1434C43.014 21.4876 45.0828 19.3429 47.7278 19.3429C49.1558 19.3429 50.1964 19.909 50.9688 20.6322L52.2404 19.3554C51.1675 18.323 49.7395 17.5325 47.7377 17.5325C44.1093 17.5325 41.0645 20.5001 41.0645 24.1335C41.0645 27.7769 44.1068 30.7345 47.7377 30.7345C49.6972 30.7345 51.1675 30.0911 52.3298 28.8791C53.5144 27.6896 53.8894 26.0113 53.8894 24.6572C53.8894 24.2357 53.8572 23.8567 53.7901 23.535H47.7154C47.7179 23.5325 47.7179 23.5549 47.7179 23.5549ZM92.8413 24.9564C92.4861 24.0013 91.4132 22.2457 89.2128 22.2457C87.0323 22.2457 85.2193 23.9689 85.2193 26.5001C85.2193 28.8891 87.0124 30.7544 89.4239 30.7544C91.3611 30.7544 92.4886 29.5649 92.953 28.8666L91.5151 27.8991C91.0382 28.6098 90.3751 29.0761 89.4338 29.0761C88.4827 29.0761 87.8171 28.6422 87.375 27.7868L93.0399 25.4302C93.0399 25.4327 92.8413 24.9564 92.8413 24.9564ZM87.0645 26.3779C87.0198 24.7345 88.3361 23.8991 89.2774 23.8991C90.02 23.8991 90.6384 24.2656 90.8495 24.7993L87.0645 26.3779ZM82.4626 30.5001H84.3227V18.0013H82.4626V30.5001ZM79.4078 23.2008H79.3407C78.921 22.6996 78.1238 22.2457 77.1056 22.2457C74.9921 22.2457 73.045 24.1135 73.045 26.5125C73.045 28.9015 74.9821 30.7469 77.1056 30.7469C78.1114 30.7469 78.921 30.2906 79.3407 29.7794H79.4078V30.3903C79.4078 32.0138 78.5435 32.8891 77.1503 32.8891C76.0103 32.8891 75.3025 32.0661 75.0144 31.3779L73.3976 32.0562C73.8621 33.1784 75.1013 34.5674 77.1478 34.5674C79.3283 34.5674 81.1761 33.2781 81.1761 30.1335V22.5001H79.4177V23.2008C79.4202 23.2008 79.4078 23.2008 79.4078 23.2008ZM77.272 29.0786C75.988 29.0786 74.9151 28.0013 74.9151 26.5125C74.9151 25.0113 75.988 23.924 77.272 23.924C78.5435 23.924 79.5295 25.0237 79.5295 26.5125C79.5419 28.0013 78.546 29.0786 77.272 29.0786ZM101.551 18.0013H97.103V30.5001H98.9632V25.7669H101.554C103.612 25.7669 105.636 24.2681 105.636 21.8891C105.636 19.51 103.62 18.0013 101.551 18.0013ZM101.606 24.0212H98.9607V19.732H101.606C102.999 19.732 103.786 20.8866 103.786 21.8766C103.786 22.8567 102.989 24.0212 101.606 24.0212ZM113.092 22.2332C111.741 22.2332 110.348 22.8342 109.772 24.1434L111.421 24.8317C111.776 24.1434 112.426 23.909 113.114 23.909C114.078 23.909 115.052 24.4876 115.074 25.52V25.6522C114.741 25.4626 114.011 25.1734 113.137 25.1734C111.356 25.1734 109.551 26.1509 109.551 27.9838C109.551 29.6621 111.011 30.7395 112.638 30.7395C113.887 30.7395 114.575 30.1734 115.004 29.5175H115.071V30.4851H116.865V25.6971C116.865 23.4676 115.215 22.2332 113.092 22.2332ZM112.859 29.0786C112.25 29.0786 111.398 28.7794 111.398 28.0113C111.398 27.0437 112.461 26.6771 113.368 26.6771C114.187 26.6771 114.575 26.8542 115.061 27.0986C114.927 28.2207 113.984 29.0686 112.859 29.0786ZM123.406 22.5001L121.27 27.9215H121.203L118.99 22.5001H116.989L120.309 30.0786L118.417 34.2906H120.354L125.463 22.5001H123.406ZM106.662 30.5001H108.522V18.0013H106.662V30.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.56 8.03364C10.2719 8.34536 10.1055 8.82167 10.1055 9.44511V31.5573C10.1055 32.1808 10.2719 32.6571 10.5699 32.9563L10.6469 33.0237L22.9851 20.6346V20.3578L10.6369 7.96631L10.56 8.03364Z",
    fill: "url(#paint0_linear_92_5677)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0899 24.7768L22.9746 20.6446V20.3553L27.0899 16.2231L27.1793 16.278L32.047 19.0561C33.4403 19.8441 33.4403 21.1458 32.047 21.9438L27.1793 24.7219L27.0899 24.7768Z",
    fill: "url(#paint1_linear_92_5677)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1784 24.7219L22.9738 20.5L10.5586 32.9663C11.0131 33.4551 11.7755 33.51 12.6274 33.0337L27.1784 24.7219Z",
    fill: "url(#paint2_linear_92_5677)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1784 16.2779L12.6274 7.97869C11.7755 7.48992 11.0106 7.55725 10.5586 8.04603L22.9738 20.4999L27.1784 16.2779Z",
    fill: "url(#paint3_linear_92_5677)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0889 24.6323L12.6372 32.8767C11.83 33.343 11.1098 33.3106 10.6453 32.8867L10.5684 32.964L10.6453 33.0313C11.1098 33.4527 11.83 33.4877 12.6372 33.0213L27.1883 24.7221L27.0889 24.6323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0457 21.7993L27.0762 24.6322L27.1656 24.7219L32.0333 21.9439C32.7312 21.5449 33.0739 21.0212 33.0739 20.5C33.0317 20.9788 32.6765 21.4327 32.0457 21.7993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6287 8.12354L32.0475 19.2008C32.6783 19.5575 33.0335 20.0238 33.0881 20.5001C33.0881 19.9789 32.7454 19.4552 32.0475 19.0562L12.6287 7.9789C11.2355 7.1784 10.1055 7.84673 10.1055 9.44523V9.58987C10.1055 7.98887 11.2355 7.33301 12.6287 8.12354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_5677",
    x1: 21.8784,
    y1: 9.20654,
    x2: 2.10396,
    y2: 14.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_92_5677",
    x1: 33.864,
    y1: 20.5,
    x2: 9.76623,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_92_5677",
    x1: 24.8921,
    y1: 22.7973,
    x2: 8.92933,
    y2: 49.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_92_5677",
    x1: 7.43231,
    y1: 0.678683,
    x2: 14.554,
    y2: 12.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_5677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    transform: "translate(0.167969 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/_google-play.2b30980f2568b5e80d72fd45a04122df.svg";
export { ForwardRef as ReactComponent };